export const reddit = {
  "userAgent": "parm.app",
  "refreshToken": "34542178-J-ujSiWPsoBUdWxU6hm0ICVWdlY",
  "clientSecret": "J37GwZ9MlTy2qszs3w3RbvF4T5s",
  "clientId": "bYcmUtL3mZ62yQ"
};